import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Collapsed = props => {
  const { children, key, onClick, isCollapsed, title } = props;

  const addedStyle = isCollapsed
    ? {
      border: "1px solid #c9d9e8",
      background: "#f2f5f8",
      borderLeft: 0,
      borderRight: 0,
      borderTopColor: "white"
    }
    : {};

  return (
    <div className="collapsableFilterTitle" key={key} style={addedStyle}>
      <div className="titleFilter" onClick={onClick}>
        {isCollapsed ? (
          <FontAwesomeIcon
            icon={["far", "angle-right"]}
            style={{
              color: "#005075",
              cursor: "pointer",
              margin: "0 10px"
            }}
          />
        ) : (
          <FontAwesomeIcon
            icon={["far", "angle-down"]}
            style={{
              color: "#005075",
              cursor: "pointer",
              margin: "0 10px"
            }}
          />
        )}
        {title}
      </div>
      {isCollapsed ? null : children}
    </div>
  );
};

export default Collapsed;
